import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA offline functionality
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // New service worker available
    console.log('New service worker available');
    // Optionally show a notification to the user
    if (registration.waiting) {
      // You can show a notification here to prompt the user to refresh
      if (window.confirm('New version available! Reload to update?')) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  },
  onSuccess: (registration) => {
    console.log('Service worker registered successfully');
  }
});

// Setup online/offline status listeners
serviceWorkerRegistration.setupOnlineStatusListener();
